import { Injectable } from "@angular/core";
import * as countries from "i18n-iso-countries";

import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

@Injectable({
  providedIn: "root",
})
export class CountryService {
  getCountries() {
    const names = countries.getNames("en", {
      select: "official",
    });

    return Object.entries(names)
      .map(([code, name]) => ({
        code,
        name,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
